// Media Galleries
Object.assign(window.HiSnaps, {
    
    galleries: {
        init() {
            const galleries = $$(".media-gallery");
            galleries.forEach(gallery => this.initGallery(gallery));
        },
        
        initGallery(gallery) {
            const wrapper = gallery.closest(".media-wrapper");
            if (!wrapper) return;
            
            const prevBtn = wrapper.querySelector(".btn.prev");
            const nextBtn = wrapper.querySelector(".btn.next");
            
            const allImages = Array.from(gallery.querySelectorAll("img"));
            let isAnimating = false;
            
            const getVisibleImages = () => {
                const currentVariantId = HiSnaps.selectedVariantId;
                if (!currentVariantId) return allImages;

                const flavorBtn = $1('.picker[data-variant-option="flavor"] .btn.selected');
                const currentFlavor = flavorBtn ? flavorBtn.dataset.value : null;

                const filtered = allImages.filter(img => {
                    const variantIds = img.dataset.variantIds;
                    const flavors = img.dataset.variantFlavors;
                    const hasIds = variantIds && variantIds !== '';
                    const hasFlavors = flavors && flavors !== '';

                    // Untargeted images show for every variant.
                    if (!hasIds && !hasFlavors) return true;

                    // Flavor-scoped: show for every size of the matching flavor.
                    if (hasFlavors && currentFlavor && flavors.split(',').includes(currentFlavor)) return true;

                    // Variant-scoped: show only for that exact variant.
                    if (hasIds && variantIds.split(',').includes(String(currentVariantId))) return true;

                    return false;
                });

                return filtered.length > 0 ? filtered : allImages;
            };
            
            const getCurrentIndex = () => {
                const visibleImages = getVisibleImages();
                const current = visibleImages.find(img => img.classList.contains("active"));
                return visibleImages.indexOf(current);
            };
            
            const updateVisibility = () => {
                const visibleImages = getVisibleImages();
                
                allImages.forEach(img => {
                    img.classList.remove("active");
                });
                
                if (visibleImages.length > 0) {
                    visibleImages[0].classList.add("active");
                }
            };
            
            const navigate = (direction) => {
                if (isAnimating) return;
                
                const visibleImages = getVisibleImages();
                const currentIndex = getCurrentIndex();
                const currentImage = visibleImages[currentIndex];
                
                if (!currentImage || visibleImages.length <= 1) return;
                
                let nextIndex;
                if (direction === "next") {
                    nextIndex = (currentIndex + 1) % visibleImages.length;
                } else {
                    nextIndex = (currentIndex - 1 + visibleImages.length) % visibleImages.length;
                }
                
                const nextImage = visibleImages[nextIndex];
                if (!nextImage) return;
                
                const directionClass = direction === "next" ? "right" : "left";
                isAnimating = true;
                
                // Animate out the current image.
                currentImage.classList.add("moving-out", directionClass);
                currentImage.classList.remove("active");
                
                // Animate in the next image.
                nextImage.classList.add("next", directionClass);
                setTimeout(() => {
                    nextImage.classList.add("active");
                }, 1);
                
                setTimeout(() => {
                    currentImage.classList.remove(directionClass, "moving-out");
                    nextImage.classList.remove("next", directionClass);
                    isAnimating = false;
                }, 240);
            };
            
            // Initial setup at page load...
            updateVisibility();
            // ... and listen for variant changes.
            const onVariantChange = () => {
                updateVisibility();
            };
            gallery.addEventListener("HiSnaps.variantChanged", onVariantChange);
            
            // Wire up the buttons.
            // Yes, these are "reversed" intentionally.
            // Even though the prior setup was technically correct, the animation made it feel
            // backwards. So rather than rewriting, just flipped the direction on each button.
            prevBtn?.addEventListener("click", () => navigate("next"));
            nextBtn?.addEventListener("click", () => navigate("prev"));
        }
    }

});